import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PublisherForm from './PublisherForm';
import { useNavigate, useParams } from 'react-router-dom';
import useCheckPermission from '../../hooks/useCheckPermission';
import publisherService from '../../services/publisherService';
import userGroupService from '../../services/authority/userGroupService';
import publisherTypeService from '../../services/publisherTypeService';

const PublisherEdit = (props: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);
  const [groups, setGroups] = useState<any[]>([]);
  const [publisherTypes, setPublisherTypes] = useState<any[]>([]);

  const [entity, setEntity] = useState<any>({
    id: 0,
    name: '',
    email: '',
    website: '',
    imageId: 0,
    groupIds: [],
    isInstitution: false,
    publisherTypeId: '',
  });

  const { checkPermission } = useCheckPermission();

  useEffect(() => {
    userGroupService.list().then((response: any) => {
      if (!response.hasError) setGroups(response.records);
      else
        enqueueSnackbar(response.errorMessages.join(','), {
          variant: 'error',
        });
    });
  }, []);

  useEffect(() => {
    publisherTypeService.list().then((response: any) => {
      if (!response.hasError) setPublisherTypes(response.records);
      else
        enqueueSnackbar(response.errorMessages.join(','), {
          variant: 'error',
        });
    });
  }, []);

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    publisherService
      .get(params.id)
      .then((response: any) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          setEntity(response.result);
        }
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, [params.id]);

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    publisherService
      .update(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', {
            variant: 'success',
          });

          navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <PublisherForm
      entity={entity}
      readonly={!checkPermission(['EditPublisher'])}
      onSubmit={onSubmit}
      handleCancel={() => navigate(-1)}
      errors={errors}
      groups={groups}
      publisherTypes={publisherTypes}
      onPublisherTypeAdded={(location: any) => {
        setPublisherTypes([...publisherTypes, location]);
      }}
    />
  );
};

export default PublisherEdit;
